import {Card, CardActions, CardContent, CardMedia, IconButton, Stack} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {CenteredCircularSpinner} from "./CenteredCircularSpinner";
import React, {useState} from "react";
import {PhotoViewer} from "./PhotoViewer";
import {ImagePreview} from "../../pages/estimate/estimate-tree-detail/EstimateTreeDetailComponent";

export interface ImagePreviewsProps {
  images: ImagePreview[],
  removeImage: (index: number) => void,
  /** The photo editor. Since SQ-572 a click opens the viewer first; its Edit Picture comes here. */
  openImageDialog: (imagePreview: ImagePreview) => void,
  countTreeImagesLoading: number,
  canRemoveImage: boolean,
  /** The page's photo editor is open (over the viewer): the viewer steps out of sight until it closes. */
  imageDialogOpen?: boolean,
  /** The viewer opened or closed: the work item / gate window hides behind it, as it does behind the editor. */
  onViewerOpenChange?: (open: boolean) => void,
}

export const ImagePreviews = (props: ImagePreviewsProps) => {
  const [viewing, setViewingState] = useState<number | null>(null);
  const setViewing = (index: number | null) => {
    setViewingState(index);
    props.onViewerOpenChange?.(index !== null);
  };
  return(
    <Stack direction="row" spacing={1}>
      <PhotoViewer
        photos={props.images.map(image => ({id: image.id, url: image.s3Url}))}
        startIndex={viewing}
        onClose={() => setViewing(null)}
        onEdit={props.canRemoveImage ? index => props.openImageDialog(props.images[index]) : undefined}
        onDelete={props.canRemoveImage ? index => props.removeImage(index) : undefined}
        deleteText="This removes the photo when you save."
        hidden={props.imageDialogOpen}
      />
      {props.images.map((imagePreview, index) => (
        <Card key={index} sx={{ maxWidth: 100 }}>
          <CardMedia
            component="img"
            height="100"
            image={imagePreview.s3Url}
            alt="Tree preview"
            onClick={() => setViewing(index)}
            sx={{ cursor: 'pointer' }}
          />
          {props.canRemoveImage && <CardActions>
            <IconButton size="small" onClick={() => props.removeImage(index)}>
              <Delete fontSize="inherit" />
            </IconButton>
          </CardActions>}
        </Card>))}
      {[...Array(props.countTreeImagesLoading)].map((_, index) => (
        <Card key={index+100} sx={{ maxWidth: 100 }}>
          <CardContent sx={{ width: 100, height: 100 }}>
            <CenteredCircularSpinner/>
          </CardContent>
          <CardActions>
            <IconButton size="small">
              <Delete fontSize="inherit" />
            </IconButton>
          </CardActions>
        </Card>
      ))}
    </Stack>)
}